<div class="login-bg">
  <div class="row w-100 align-items-center">
    <div class="col-lg-6 d-flex">
      <div class="auth-logo m-auto">
        <img src="assets/images/admin-logo-v2.png" class="img-fluid" alt="" />
      </div>
    </div>
    <div class="col-lg-6">
      <div class="splash-container login-wrap d-flex align-items-center">
        <div class="card px-2 py-5 mb-0">
          <div class="card-body">
            <!-- <div class="alert alert-danger">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <i class="material-icons">close</i>
              </button>
            </div> -->
            <div class="headbox text-center">
              <h1>Verify Email</h1>
              <span class="splash-description">Please verify your email</span>
            </div>
            <div class="middle-area"> 
              <form [formGroup]="emailForm">
                <div class="form-group mb-3">
                  <input type="email" class="form-control form-control-lg" formControlName="email" placeholder="Email" required>
                  <div *ngIf="submitted || emailForm.get('email')?.hasError('required') && emailForm.get('email')?.touched"
                    class="error-message">Email is required</div>
                </div>
                <div class="btn-wrap text-center">
                  <button type="submit" class="btn btn-lg btn-block btn-primary" (click)="onSubmit()">Verify Email</button>
                </div>
              </form>
            </div>
          </div>
          <div class="card-footer d-flex bg-white p-0">
            <div class="card-footer-item card-footer-item-bordered">
              <a href="javascript:void(0);" (click)="login()" class="red-link">Login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>